import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-613e8482"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "animate" }
const _hoisted_2 = { class: "footer-container" }
const _hoisted_3 = { class: "footer-row" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_6 = { class: "footer-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "link_title" }, "Redes sociales", -1))
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "footer-row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "link_title" }, "Links", -1))
const _hoisted_17 = {
  class: "footer-row",
  style: {"margin-bottom":"35px"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "link_title" }, "Legal", -1))
const _hoisted_20 = ["href"]
const _hoisted_21 = ["href"]
const _hoisted_22 = ["href"]
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "footer-row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "link_title" }, "Contacto", -1))
const _hoisted_27 = ["href"]
const _hoisted_28 = ["href"]
const _hoisted_29 = ["href"]
const _hoisted_30 = ["href"]
const _hoisted_31 = ["href"]
const _hoisted_32 = { class: "advice" }

import main from '@/data/main.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterBar',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(main).LOGO_FOOTER_URI,
          width: "300"
        }, null, 8, _hoisted_4),
        _hoisted_5,
        _createElementVNode("p", null, _toDisplayString(_unref(main).NAME_COMPLETE_COMPANY), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(main).NAME_STREET), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(main).POSTAL_CODE) + " | " + _toDisplayString(_unref(main).COMPANY_CITY), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("a", {
          href: _unref(main).LINK_FACEBOOK,
          target: "_blank",
          class: "link"
        }, "Facebook", 8, _hoisted_9),
        _createElementVNode("a", {
          href: _unref(main).LINK_YOUTUBE,
          target: "_blank",
          class: "link"
        }, "Youtube", 8, _hoisted_10),
        _createElementVNode("a", {
          href: _unref(main).LINK_INSTAGRAM,
          target: "_blank",
          class: "link"
        }, "Instagram", 8, _hoisted_11),
        _createElementVNode("a", {
          href: _unref(main).SCHOOL_URL,
          target: "_blank",
          class: "link"
        }, "Web", 8, _hoisted_12),
        _createElementVNode("a", {
          href: _unref(main).LINK_X,
          target: "_blank",
          class: "link"
        }, "X", 8, _hoisted_13)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _hoisted_16,
        _createVNode(_component_RouterLink, {
          to: {name:'roadmaps'},
          class: "link"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Itinerarios formativos")
          ]),
          _: 1
        }),
        _createVNode(_component_RouterLink, {
          to: {name: 'courses'},
          class: "link"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cursos formativos")
          ]),
          _: 1
        }),
        _createVNode(_component_RouterLink, {
          to: {name: 'certifications'},
          class: "link"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Certificaciones")
          ]),
          _: 1
        }),
        _createVNode(_component_RouterLink, {
          to: {name: 'auth'},
          class: "link"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Acceso / Registro")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _hoisted_19,
        _createElementVNode("a", {
          href: `${_unref(main).PRIVACY_POLICY}`,
          target: "_blank",
          class: "link"
        }, "Política de privacidad", 8, _hoisted_20),
        _createElementVNode("a", {
          href: `${_unref(main).TERMS_OF_USE}`,
          target: "_blank",
          class: "link"
        }, "Términos de uso", 8, _hoisted_21),
        _createElementVNode("a", {
          href: `${_unref(main).LEGAL_NOTICE}`,
          target: "_blank",
          class: "link"
        }, "Aviso legal", 8, _hoisted_22),
        _createElementVNode("a", {
          href: `${_unref(main).COOKIE_POLICY}`,
          target: "_blank",
          class: "link"
        }, "Política de cookies", 8, _hoisted_23)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _hoisted_26,
        (_unref(main).EMAIL_INFO != '')
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: `mailto:${_unref(main).EMAIL_INFO}`,
              target: "_blank",
              class: "link"
            }, _toDisplayString(_unref(main).EMAIL_INFO), 9, _hoisted_27))
          : _createCommentVNode("", true),
        (_unref(main).EMAIL_SUPPORT!= '')
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: `mailto:${_unref(main).EMAIL_SUPPORT}`,
              target: "_blank",
              class: "link"
            }, _toDisplayString(_unref(main).EMAIL_SUPPORT), 9, _hoisted_28))
          : _createCommentVNode("", true),
        (_unref(main).EMAIL_RECRUITMENT != '')
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              href: `mailto:${_unref(main).EMAIL_RECRUITMENT}`,
              target: "_blank",
              class: "link"
            }, _toDisplayString(_unref(main).EMAIL_RECRUITMENT), 9, _hoisted_29))
          : _createCommentVNode("", true),
        (_unref(main).EMAIL_BUSINESS != '')
          ? (_openBlock(), _createElementBlock("a", {
              key: 3,
              href: `mailto:${_unref(main).EMAIL_BUSINESS}`,
              target: "_blank",
              class: "link"
            }, _toDisplayString(_unref(main).EMAIL_BUSINESS), 9, _hoisted_30))
          : _createCommentVNode("", true),
        (_unref(main).EMAIL_ADMINISTRATION != '')
          ? (_openBlock(), _createElementBlock("a", {
              key: 4,
              href: `mailto:${_unref(main).EMAIL_ADMINISTRATION}`,
              target: "_blank",
              class: "link"
            }, _toDisplayString(_unref(main).EMAIL_ADMINISTRATION), 9, _hoisted_31))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("p", _hoisted_32, _toDisplayString(_unref(main).NAME_COMPANY_FOOTER) + " © Todos los derechos reservados. Versión: " + _toDisplayString(_unref(main).VERSION), 1)
  ]))
}
}

})